import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby';

import './section-promo-releated.scss';
import CardPromo from '../../atoms/card-promo/card-promo';

const SectionPromoReleated = props => {
    const { promo } = props;
    const { tags, id } = promo;
    const tag = tags[0];

    const resultQuery = useStaticQuery(
        graphql`
            {
                allContentfulPromocion {
                    nodes {
                        id
                        logo {
                            file {
                                url
                            }
                        }
                        titulo
                        texto
                        llamadaALaAccion
                        textoBotonSecundario
                        enlaceBotonSecundario
                        tags
                        fechaDeInicio
                        fechaDeFin
                        slug
                    }
                }
            }
        `
    );

    const promociones = resultQuery.allContentfulPromocion.nodes.filter( promo => {
        var now = new Date();
        var inicio = new Date(promo.fechaDeInicio);
        var fin = new Date(promo.fechaDeFin);
        return now > inicio && now < fin;
    });

    const [listPromoReleated, setListPromoReleated] = useState([]);

    useEffect(() => {
        selectReleated();
    }, [promo])

    const selectReleated = () => {
        var promos = promociones.filter( p => p.tags.find( t => t === tag ) && p.id !== id );
        if(promos.length < 3){
            promos = [...new Set( promos.concat( promociones.filter( p => p.id !== id ) ) )];
        }
        setListPromoReleated( promos.slice(0, 3) );
    }

    return (
        <div className="o-section-promo-releated">
            <div className="o-section-promo-releated_container">
                <h2>Muchas más promociones para ti</h2>
                <p>Obtén beneficios especiales con nuestras tarjetas de crédito hechas a tu medida.</p>
                <div className="o-section-promo-releated_list-promos">
                    {
                        listPromoReleated.map( (promo,index) => ( 
                            <CardPromo  promo={ promo } key={ index }/>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default SectionPromoReleated
